import Vue from "vue";
import router from "../router/";
import $config from "@/config/baseConfig";
import { compressAccurately } from "image-conversion";
/**
 * @description: 路由跳转
 */
export const routeTo = (params) => {
  router.push(params);
};
export const routeReplace = (params) => {
  router.replace(params);
};

/**
 * @description: 递归查询指定数据
 * @param {type}
 * @return:
 */
export const findData = (data, keys) => {
  keys = keys.split(".");
  for (let i = 0; i < keys.length; i++) {
    if (!keys[i]) return data;
    data = data[keys[i]];
  }
  return data;
};

/**
 * @description: tree转一维数组
 * @param {type}
 * @return:
 */
export const treeTransArray = (tree, key) => {
  return [].concat(
    ...tree.map((item) => {
      if (item[key] && item[key].length) {
        return [].concat(item, ...treeTransArray(item[key]), key);
      } else {
        return item;
      }
    })
  );
};

//对象转url参数
export const objectToUrlParams = (keys) => {
  let urlParams = "";
  for (let i in keys) {
    urlParams += i + "=" + keys[i] + "&";
  }
  urlParams = urlParams.substring(0, urlParams.length - 1);
  return urlParams;
};

/**
 * @description: 获取头像
 * @param {type}
 * @return:
 */
export const getAvatarUrl = (url) => {
  if (url) {
    return $config.fileUrl + url;
  } else {
    return "/images/avatar.jpg";
  }
};

/**
 * @description: 样式是否存在
 * @param {*} elements
 * @param {*} cName
 * @return {*}
 */
export const hasClass = (elements, cName) => {
  return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
};

/**
 * @description: 新增样式
 * @param {*} elements
 * @param {*} cName
 * @return {*}
 */
export const addClass = (elements, cName) => {
  if (!hasClass(elements, cName)) {
    elements.className += " " + cName;
  }
};

/**
 * @description: 删除样式
 * @param {*} elements
 * @param {*} cName
 * @return {*}
 */
export const removeClass = (elements, cName) => {
  if (hasClass(elements, cName)) {
    elements.className = elements.className.replace(
      new RegExp("(\\s|^)" + cName + "(\\s|$)"),
      " "
    );
  }
};

/**
 * @description: moment 转 字符串
 * @param {*} date
 * @param {*} format
 * @return {*}
 */
export const onMomentToString = function(date, format = "YYYY-MM-DD") {
  return !date ? date : date.format ? date.format(format) : date;
};

/**
 * @description: YYYY-MM-DD HH:mm:ss || HH:mm:ss 截取时分秒
 * @param {*} date
 * @return {*}
 */
export const onDateSplitTime = function(date) {
  date = onMomentToString(date, "YYYY-MM-DD HH:mm:ss");
  let dateArr = date.split(",");
  return dateArr.length > 1 ? dateArr[1] : dateArr[0];
};

/**
 * @description: 删除url删除并跳转
 * @param {*} paramKey
 * @return {*}
 */
export const deleteParam = (paramKey) => {
  let url = window.location.href; //页面url
  const urlParam = window.location.search.substr(1); //页面参数
  const beforeUrl = url.substr(0, url.indexOf("?")); //页面主地址（参数之前地址）
  let nextUrl = "";
  const arr = [];
  if (urlParam != "") {
    const urlParamArr = urlParam.split("&"); //将参数按照&符分成数组
    for (let i = 0; i < urlParamArr.length; i++) {
      const paramArr = urlParamArr[i].split("="); //将参数键，值拆开
      if (paramArr[0] != paramKey) {
        arr.push(urlParamArr[i]);
      }
    }
  }
  if (arr.length > 0) {
    nextUrl = "?" + arr.join("&");
  }
  url = beforeUrl + nextUrl;
  return url;
};

/**
 * @description: 压缩图标  图片上传大小判断
 * @param {*} file
 * @return {*}
 */
export const compressUploadImage = (file, maxSize = 1024) => {
  return new Promise((resolve, reject) => {
    const imageLimit = maxSize > 200 ? maxSize - 100 : maxSize;
    if (file.size > maxSize * 1024) {
      const config = {
        type: file.type,
        size: imageLimit,
      };
      compressAccurately(file, config)
        .then((blob) => {
          let newFile = new window.File([blob], file.name, {
            type: file.type,
          });
          newFile.uid = file.uid;
          resolve(newFile);
        })
        .catch(() => {
          reject();
        });
    } else {
      resolve(file);
    }
  });
};

/**
 * @description: 两个数组 是否存在交集
 * @param {*} arr1
 * @param {*} arr2
 * @return {*}
 */
export const isIntersect = function(arr1, arr2) {
  return (
    arr1.length + arr2.length !== Array.from(new Set([...arr1, ...arr2])).length
  );
};

/**
 * @description: 根据size 拆分数组为 二维数组
 * @param {*} array
 * @param {*} size
 * @return {*}
 */
export const splitArrayByLength = (array, size) => {
  //获取数组的长度，如果你传入的不是数组，那么获取到的就是undefined
  const length = array.length;
  //判断不是数组，或者size没有设置，size小于1，就返回空数组
  if (!length || !size || size < 1) {
    return [];
  }
  //核心部分
  let index = 0; //用来表示切割元素的范围start
  let resIndex = 0; //用来递增表示输出数组的下标

  //根据length和size算出输出数组的长度，并且创建它。
  let result = new Array(Math.ceil(length / size));
  //进行循环
  while (index < length) {
    //循环过程中设置result[0]和result[1]的值。该值根据array.slice切割得到。
    result[resIndex++] = array.slice(index, (index += size));
  }
  //输出新数组
  return result;
};

/**
 * @description: 清空对象中的空值
 * @param {*}
 * @return {*}
 */
export const clearObjectEmpty = (data) => {
  for (let i in data) {
    if (
      data[i] === "" ||
      data[i] === null ||
      (data[i] instanceof Array && data[i].length == 0) ||
      (i.indexOf("Id") > 0 && data[i] == 0)
    ) {
      delete data[i];
    }
  }
  return data;
};

/**
 * @description: 生成一个 不重复的
 * @param {*}
 * @return {*}
 */
export const randomNumber = (number = 36) => {
  return (new Date().getTime() + Math.random() * 99999).toString(number);
};

export const isOjbect = (data) => {
  return Object.prototype.toString.call(data) === "[object Object]";
};

//是否空对象
export const isEmptyObject = (data) => {
  return JSON.stringify(data) === "{}";
};

/**
 * @description: 判断是否空值或者null
 * @param {*} value
 * @return {*}
 */
export const isEmptyOrNull = (value) => {
  return !(value || value === 0 || value === false);
};
export const jump = (name, query = {}, params = {}) => {
  router.push({
    name: name,
    query: query,
    params: params,
  });
};
const cacheObj = {
  set(name, value, expire) {
    if (expire) {
      return Vue.ls.set(name, value, expire);
    } else {
      return Vue.ls.set(name, value);
    }
  },
  get(name) {
    return Vue.ls.get(name);
  },
  remove(name) {
    return Vue.ls.remove(name);
  },
};

export const cache = cacheObj;

export const accAdd = (arg1, arg2) => {
  var r1, r2, m, c;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));
  if (c > 0) {
    var cm = Math.pow(10, c);
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace(".", ""));
      arg2 = Number(arg2.toString().replace(".", "")) * cm;
    } else {
      arg1 = Number(arg1.toString().replace(".", "")) * cm;
      arg2 = Number(arg2.toString().replace(".", ""));
    }
  } else {
    arg1 = Number(arg1.toString().replace(".", ""));
    arg2 = Number(arg2.toString().replace(".", ""));
  }
  return (arg1 + arg2) / m;
};
export const accSub = (arg1, arg2) => {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
  n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
};
export const accMul = (arg1, arg2) => {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
};

//除法函数
export const accDiv = (arg1, arg2) => {
  var t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = arg1.toString().split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  try {
    t2 = arg2.toString().split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}

  r1 = Number(arg1.toString().replace(".", ""));

  r2 = Number(arg2.toString().replace(".", ""));
  return (r1 / r2) * Math.pow(10, t2 - t1);
};
